import { useAppStore } from './app';
import { useDeveloperSettingsStore } from './developer-settings';
import { appStoreKey } from 'commercial-web-client-utilities/dist/store/app';
import { developerSettingsStoreKey } from 'commercial-web-client-utilities/dist/store/developer-settings';

import type { Plugin } from 'vue';

export const appStorePlugin: Plugin = {
    install(app) {
        const appStore = useAppStore();
        app.provide(appStoreKey, () => appStore as never);
        appStore.initialize();
    }
};

export const developerSettingsStorePlugin: Plugin = {
    install(app) {
        const developerSettingsStore = useDeveloperSettingsStore();
        app.provide(developerSettingsStoreKey, () => developerSettingsStore as never);
    }
};

export { useAppStore, useDeveloperSettingsStore };
export type { AppStore } from './app';
export type { DeveloperSettingsStore } from './developer-settings';